import React, { memo } from 'react';
import { ToolbarExportIcons } from '../../../../../../icons/icons';
import { ExportButtonProps } from './index';

export const ExportButton = memo<ExportButtonProps>(({ handleExport }) => (
  <button
      onClick={handleExport}
      className='group flex min-h-8 items-center gap-1.5 whitespace-nowrap rounded-lg border border-emerald-100 bg-emerald-50 px-2.5 text-xs font-semibold text-emerald-600 transition-all duration-300 hover:bg-emerald-100/80 active:bg-emerald-200/50'
      title='Export data as CSV file'
      aria-label='Export data as CSV file'
  >
    <ToolbarExportIcons className='w-3.5 h-3.5 group-hover:-translate-y-0.5 transition-transform duration-200' />
    <span className='hidden sm:block'>Export CSV</span>
    <span className='sm:hidden'>Export</span>
  </button>
));

ExportButton.displayName = 'ExportButton';
